import type { CameraMappingType } from "~/entities/camera/types";
import axiosInstance from "~/shared/api/axios-instance";

export const updateCameraMapping = async (params: {
  branchUid: string;
  versionId?: number;
  cameraOrientationId: number;
  floorPlanId: number | null;
  position: { x: number; y: number; rotation: number } | null;
  mappingType: CameraMappingType;
  additionId?: string | null;
  adjustmentId?: string | null;
}) => {
  const body: Record<string, unknown> = {
    version: params.versionId,
    floor_plan_id: params.floorPlanId,
    position: params.position
      ? {
          x: params.position.x,
          y: params.position.y,
          rotation: params.position.rotation,
        }
      : null,
  };

  // 추가/조정 상태 전달 — 서버는 비어있는 extra_id/adjustment_id 를 거절 (400)
  if (params.mappingType === "add") {
    body.extra_camera_orientation_status = {
      extra_id: params.additionId && params.additionId.length > 0 ? params.additionId : String(Date.now()),
    };
    body.adjustment_status = null;
  } else if (params.mappingType === "edit" && params.position) {
    body.adjustment_status = {
      adjustment_id: params.adjustmentId && params.adjustmentId.length > 0 ? params.adjustmentId : String(Date.now()),
      position: {
        x: params.position.x,
        y: params.position.y,
        rotation: params.position.rotation,
      },
      frame: { dx: 0, dy: 0 },
    };
    body.extra_camera_orientation_status = null;
  } else if (params.floorPlanId === null) {
    // 매핑 해제 (default + floor_plan_id=null) — 상태 초기화
    body.extra_camera_orientation_status = null;
    body.adjustment_status = null;
  }
  // default + floor_plan_id != null → 단순 이동: 상태 필드를 body 에 포함하지 않아 서버 값 보존 (legacy 패턴)

  const { data } = await axiosInstance.patch(
    `branches/${params.branchUid}/pseudo-camera-orientations/${params.cameraOrientationId}/`,
    body,
  );
  return data;
};
